<style scoped lang="scss">
.dropdown {
  position: relative;
  display: inline-block;
}

#searchInput {
  box-sizing: border-box;
  background-position: 14px 12px;
  background-repeat: no-repeat;
  font-size: 16px;
  padding: 14px 20px 12px 45px;
  border: none;
  border-bottom: 1px solid #ddd;
}
#searchInput:focus {
  outline: 3px solid #ddd;
}
.dropdown-item:hover {
  background-image: none;
  background-color: $primary;
}
</style>
<template>
  <div>
    <div
      class="dropdown"
      :class="{ show: show, dropdown: true, 'is-invalid': hasErrors }"
      ref="dropdown"
    >
      <button
        @click="show = !show"
        class="btn btn-primary dropdown-toggle"
        type="button"
      >
        <a v-if="vmodel" class="">
          <a :href="profileUrl(vmodel)" class="text-white pl-2">
            {{ vmodel["name"] }}
          </a>
        </a>
        <a v-else> Wähle ein Moderator... </a>
      </button>
      <div :id="id" class="dropdown-menu" :class="{ show: show }">
        <input
          type="text"
          placeholder="Search.."
          ref="searchInput"
          v-model="search"
          id="searchInput"
          @keyup="filterFunction()"
        />
        <a
          v-for="model in models"
          :key="model.id"
          @click="select(model)"
          class="dropdown-item p-0 m-0 align-items-center"
        >
          <span class="pl-2"> {{ model["name"] }} </span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";
export default {
  data() {
    return {
      vmodel: null,
      models: [],
      show: false,
      id: "ModeratorDropdown",
      search: ""
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  computed: {
    hasErrors() {
      return false;
    }
  },
  methods: {
    async filterFunction() {
      if (this.search.length >= 3) {
        let filter = [
          {
            name: "name",
            attributes: "user",
            value: this.search
          },
          {
            name: "with",
            value: "user"
          }
        ];
        const { data } = await this.$http.get(`/api/v1/moderator`, {
          params: { filter: filter }
        });
        this.models = data;
      }
    },
    select(model) {
      this.vmodel = model;
      this.$emit("input", this.vmodel["id"]);
      this.show = false;
    },
    profileUrl(model) {
      return `/moderator/detail/${model.id}`;
    }
  }
};
</script>
